import { cn } from '@/lib/utils';

interface PhoneMockupProps {
  children: React.ReactNode;
  className?: string;
}

export function PhoneMockup({ children, className }: PhoneMockupProps) {
  return (
    <div
      className={cn(
        'relative mx-auto w-[280px] rounded-[3rem] border-[6px] border-gray-800 bg-gray-900 p-2 shadow-2xl',
        className,
      )}
      style={{
        transform: 'perspective(1000px) rotateY(-5deg) rotateX(2deg)',
      }}
    >
      {/* Notch */}
      <div className="absolute top-0 left-1/2 z-10 h-6 w-28 -translate-x-1/2 rounded-b-2xl bg-gray-800" />

      {/* Screen */}
      <div className="relative overflow-hidden rounded-[2.25rem] bg-gray-950">
        {children}
      </div>
    </div>
  );
}
